import type Geometry from 'ol/geom/Geometry'
import type Feature from 'ol/Feature'
import Point from 'ol/geom/Point'

import { setVehicleFeatureMetadata } from '../vehicleFeatureMetadata'
import { getVehicleFeatureStyles } from './getVehicleFeatureStyles'

export const updateVehicleFeature = (
  mapStyles: uui.domain.ui.map.markers.MapStyles['vehicle'],
  marker: uui.domain.ui.map.markers.Vehicle,
  feature: Feature<Geometry>,
  selected: boolean = false,
): Feature<Geometry> => {
  // ------------------------
  // Feature Geometry
  // ------------------------
  const newPoint = new Point(marker.lonLat)

  // Set default feature as 'label' and update geometry
  feature.setGeometryName('label')
  feature.setGeometry(newPoint)

  // Switch back to default feature and update geometry
  feature.setGeometryName('geometry')
  feature.setGeometry(newPoint)
  // ------------------------
  // Feature Metadata
  // ------------------------

  // update current feature mode
  const mode: uui.domain.ui.map.markers.MapStyles['vehicle']['mode'] = marker.mode ?? mapStyles.mode
  setVehicleFeatureMetadata(feature, 'mode', mode)

  // ------------------------
  // Feature Style

  feature.setStyle(getVehicleFeatureStyles(marker, mode, selected))

  return feature
}
